import "./index.es.js";
import { defineAsyncComponent as e } from "vue";
import { getI18n as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var n = {
	en: {
		hubPagesApi: {
			createAlreadyExists: "The hub page cannot be created because another hub page with this name already exists.",
			updateAlreadyExists: "The hub page cannot be updated because another hub page with this name already exists.",
			created: "Hub page created",
			updated: "Hub page updated",
			notFound: "Hub page not found",
			requiredFields: "The hub page cannot be saved because mandatory information is missing.",
			deleted: "HubPage deleted",
			errorOnDeleting: "Error on deleting HubPage"
		},
		hubPagesList: {
			newButton: "New hub page",
			name: "Search for title",
			headerRelatedTagEntities: "Linked entities",
			headerRelatedHubPages: "Related hub pages",
			headerRelatedContents: "Linked contents",
			minScoreThreshold: "Minimum entity score",
			deleteHubPages: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading hub page",
			headerLabel: "Title",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			headerPublishedAt: "Publish date",
			headerLatestPublishDate: "Latest article",
			headerSalienceScore: "Salience Score",
			headerSourceEntity: "Source Entity",
			headerTagType: "Type",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting hub page",
			errorOnLoadingReferences: "Error loading references",
			createHubPages: "Create hub page",
			headerStatus: "Status",
			type: "Type",
			noEditTooltip: "This hub page is originally from {source} editor.",
			selectHubPage: "Select hub page"
		},
		hubPages: {
			hubPagesLabel: "Hub pages",
			newHubPages: "New hub page",
			messageDeleteHubPages: "Delete hub page",
			messageDeleteHubPagesTitle: "Are you sure you want to delete this hub page?",
			deleteHubPages: "Delete",
			messageDeleted: "Hub page deleted",
			errorOnDeleting: "Error deleting the hub page",
			errorFailedLoadedHubPagesWithId: "Error getting hub page",
			handledInLegacySystem: "This hub page is handled in {source} and cannot be edited in Vibe.",
			peopleTab: "Edit person",
			profile: "Profile",
			imageSelector: "Select or upload main image",
			typeAll: "All types"
		},
		hubPagesEdit: {
			label: "Title",
			type: "Hub page type",
			counter: "Counter",
			editHubPages: "Edit hub page",
			messageSaved: "New hub page saved",
			linkTags: "Link entities",
			linkHubPages: "Connect hub pages",
			toHubPages: "To hub page",
			urlSlug: "URL slug",
			pathConflictNotice: {
				template: "This path is in conflict with {pathType} path of another HubPage. Only {pathRoutable} HubPage will be reachable!",
				pathTypeCurrent: "the current",
				pathTypeOld: "an old",
				pathRoutableThis: "this",
				pathRoutableOther: "the other"
			},
			toTag: "To entity",
			headerRelatedTags: "Linked entities",
			headerRelatedHubPages: "Related hub pages",
			generatePath: "Automatically generate path",
			showOnListPage: "Show on overview page",
			overviewTitle: "Title on overview page",
			publishSettings: "Publishing settings",
			publishDate: "Publish date",
			unpublishDate: "Unpublish date",
			shownDate: "Display date",
			deleteHubPages: "Delete hub page",
			duplicateHubPages: "Duplicate hub page",
			duplicateHubPagesMessage: "Are you sure you want to duplicate this hub page?",
			duplicate: "Duplicate",
			takeOffline: "Unpublish date",
			selectTag: "Select entity",
			nowLabel: "Set to now",
			saveAsDraft: "Save as draft",
			updateShownDate: "Update display date",
			updateShownDatePopup: "Automatically update the display date to the current timestamp when you save or publish the article.",
			modeUnpublished: "Hub page offline",
			modeScheduled: "Publish date",
			modePublished: "Published",
			modeDraft: "Draft",
			noTagsLinked: "No entities linked"
		},
		hubPageType: {
			people: "People",
			hubpages: "Hub page",
			brand: "Brand"
		},
		tagEntities: { newHubPages: "New entity" },
		tagEntitiesList: {
			headerLabel: "Title",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			brand: "Brand",
			category: "Category",
			categories: {
				LOCATION: {
					label: "Location",
					description: "Countries, cities, regions, bodies of water and facilities."
				},
				PERSON: {
					label: "Person",
					description: "Individuals, politicians, executives, celebrities and athletes."
				},
				ANIMAL: {
					label: "Animal",
					description: "Animals."
				},
				PLANT: {
					label: "Plant",
					description: "Plants, mushrooms and flora."
				},
				ORGANIZATION: {
					label: "Organization",
					description: "Companies, governments, political parties, alliances, NGOs and teams."
				},
				EVENT: {
					label: "Event",
					description: "Wars, summits, elections, sports events, disasters and historic milestones."
				},
				PRODUCT: {
					label: "Product",
					description: "Consumer goods, tech devices, vehicles, software and media titles."
				},
				LAW: {
					label: "Law",
					description: "Statutes, legal codes, court rulings and constitutional articles."
				},
				OBJECT: {
					label: "Object",
					description: "Commodities, military equipment and chemical or biological assets."
				},
				CONCEPT: {
					label: "Concept",
					description: "Abstract ideas, themes, topics and notions."
				}
			},
			dpEdit: "Edit",
			dpView: "View",
			deleteTagEntities: "Delete",
			newButton: "New entity",
			errorOnDeleting: "Error deleting entity",
			errorOnLoadingContents: "Error loading contents",
			messageDeleted: "Entity deleted",
			selectTag: "Select entity",
			headerRelatedContents: "Published contents",
			headerRelatedHubPages: "Linked hub pages",
			headerLatestPublishDate: "Latest article",
			headerSalienceScore: "Salience Score",
			messageDeleteTagEntitiesTitle: "Delete entity",
			messageDeleteTagEntities: "Are you sure you want to delete this entity?",
			messageDeleteTagEntitiesAssignment: "Are you sure you want to remove this content assignment from the entity?",
			messageDeleteTagEntitiesAssignmentTitle: "Delete content assignment",
			deleteTagEntitiesAssignment: "Delete",
			errorOnDeletingAssignment: "Error deleting assignment",
			messageDeletedAssignment: "Assignment deleted"
		},
		tagEntitiesEdit: {
			editHubPages: "Edit entity",
			label: "Title",
			canonicalName: "Canonical name",
			adjustEntityName: "Adjust entity name",
			confirmNameChangeTitle: "Change entity name",
			confirmNameChangeMessage: "Do you want to change the entity name from “{previousName}” to “{newName}”?",
			category: "Category",
			addArticles: "Add articles",
			noContentAssignments: "No content assignments",
			loadingContent: "Loading content",
			assignment: "Assignment",
			manualAssignment: "Manual assignment",
			automaticAssignment: "Automatic assignment (MDS)",
			contentTitle: "Main headline",
			contentBrand: "Content brand",
			headerStatus: "Status",
			headerSalienceScore: "Salience Score",
			headerActions: "Actions",
			dpGoToArticle: "Go to article",
			copyArticleUrl: "Copy article URL",
			copiedArticleUrl: "Article URL copied",
			messageSaved: "Entity saved"
		},
		peopleProfileHubPages: {
			firstName: "First name",
			lastName: "Last name",
			birthDate: "Date of birth",
			deathDate: "Date of death",
			birthPlace: "Place of birth",
			size: "Size (cm)",
			zodiacSign: "Zodiac sign",
			zodiacSigns: {
				aquarius: "Aquarius",
				pisces: "Pisces",
				aries: "Aries",
				taurus: "Taurus",
				gemini: "Gemini",
				cancer: "Cancer",
				leo: "Leo",
				virgo: "Virgo",
				libra: "Libra",
				scorpio: "Scorpio",
				sagittarius: "Sagittarius",
				capricorn: "Capricorn"
			}
		}
	},
	de: {
		hubPagesApi: {
			createAlreadyExists: "Die Hub-Page kann nicht erstellt werden, da bereits eine Hub-Page mit diesem Namen existiert.",
			updateAlreadyExists: "Die Hub-Page kann nicht aktualisiert werden, da bereits eine Hub-Page mit diesem Namen existiert.",
			created: "Hub-Page erstellt",
			updated: "Hub-Page aktualisiert",
			notFound: "Hub-Page nicht gefunden",
			requiredFields: "Die Hub-Page kann nicht gespeichert werden, da Pflichtinformationen fehlen.",
			deleted: "HubPage gelöscht",
			errorOnDeleting: "Fehler beim Löschen der HubPage"
		},
		hubPagesList: {
			newButton: "Neue Hub-Page",
			name: "Suchen nach Titel",
			headerRelatedTagEntities: "Verlinkte Entitäten",
			headerRelatedHubPages: "Ähnliche Hub-Pages",
			headerRelatedContents: "Verlinkte Inhalte",
			minScoreThreshold: "Mindest-Salienz-Score",
			deleteHubPages: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Hub-Page wird geladen",
			headerLabel: "Titel",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (Last modified)",
			headerPublishedAt: "Veröffentlichungsdatum",
			headerLatestPublishDate: "Neuester Artikel",
			headerSalienceScore: "Salienz-Score",
			headerSourceEntity: "Quell-Entität",
			headerTagType: "Typ",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen der Hub-Page",
			errorOnLoadingReferences: "Fehler beim Laden der Referenzen",
			createHubPages: "Hub-Page erstellen",
			headerStatus: "Status",
			type: "Typ",
			noEditTooltip: "Diese Hub-Page stammt ursprünglich vom {source}-Editor.",
			selectHubPage: "Hub-Page auswählen"
		},
		hubPages: {
			hubPagesLabel: "Hub-Pages",
			newHubPages: "Neue Hub-Page",
			messageDeleteHubPages: "Hub-Page löschen",
			messageDeleteHubPagesTitle: "Willst du diese Hub-Page wirklich löschen?",
			deleteHubPages: "Löschen",
			messageDeleted: "Hub-Page gelöscht",
			errorOnDeleting: "Fehler beim Löschen der Hub-Page",
			errorFailedLoadedHubPagesWithId: "Fehler beim Abrufen der Hub-Page",
			handledInLegacySystem: "Diese Hub-Page wird in {source} verwaltet und kann nicht in Vibe bearbeitet werden.",
			peopleTab: "Person bearbeiten",
			profile: "Steckbrief",
			imageSelector: "Bild auswählen oder hochladen",
			typeAll: "Alle"
		},
		hubPagesEdit: {
			label: "Titel",
			type: "Hub-Page-Typ",
			counter: "Zähler",
			editHubPages: "Hub-Page bearbeiten",
			messageSaved: "Neue Hub-Page gespeichert",
			linkTags: "Entitäten verlinken",
			linkHubPages: "Hub-Pages zuordnen",
			toHubPages: "Zur Hub-Page",
			urlSlug: "URL-Slug",
			pathConflictNotice: {
				template: "Dieser Pfad überschneidet sich mit {pathType} Pfad einer anderen Hub-Page. Nur {pathRoutable} Hub-Page ist erreichbar!",
				pathTypeCurrent: "dem aktuellen",
				pathTypeOld: "einem alten",
				pathRoutableThis: "diese",
				pathRoutableOther: "die andere"
			},
			toTag: "Zur Entität",
			headerRelatedTags: "Verlinkte Entitäten",
			headerRelatedHubPages: "Verwandte Hub-Pages",
			generatePath: "Pfad automatisch generieren",
			showOnListPage: "Hub-Page auf Übersichtsseite anzeigen",
			overviewTitle: "Titel auf Übersichtsseite",
			publishSettings: "Veröffentlichungseinstellungen",
			publishDate: "Veröffentlichungsdatum (publish date)",
			unpublishDate: "Ablaufdatum",
			shownDate: "Anzeigedatum (display date)",
			deleteHubPages: "Hub-Page löschen",
			duplicateHubPages: "Hub-Page duplizieren",
			duplicateHubPagesMessage: "Willst du diese Hub-Page wirklich duplizieren?",
			duplicate: "Duplizieren",
			takeOffline: "Ablaufdatum",
			selectTag: "Entität auswählen",
			nowLabel: "Auf jetzt einstellen",
			saveAsDraft: "Als Entwurf speichern",
			updateShownDate: "Anzeigedatum (display date) aktualisieren",
			updateShownDatePopup: "Anzeigedatum (display date) beim Speichern oder Veröffentlichen des Artikels automatisch auf den aktuellen Zeitstempel aktualisieren.",
			modeUnpublished: "Hub-Page depubliziert",
			modeScheduled: "Veröffentlichungsdatum (publish date)",
			modePublished: "Veröffentlicht",
			modeDraft: "Entwurf",
			noTagsLinked: "Keine Entitäten verknüpft"
		},
		hubPageType: {
			people: "Person",
			hubpages: "Hub-Page",
			brand: "Marke"
		},
		tagEntities: { newHubPages: "Neue Entität" },
		tagEntitiesList: {
			headerLabel: "Titel",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			brand: "Marke",
			category: "Kategorie",
			categories: {
				LOCATION: {
					label: "Ort",
					description: "Länder, Städte, Regionen, Gewässer und Einrichtungen."
				},
				PERSON: {
					label: "Person",
					description: "Einzelpersonen, Politiker, Führungskräfte, Prominente und Sportler."
				},
				ANIMAL: {
					label: "Tier",
					description: "Tiere."
				},
				PLANT: {
					label: "Pflanze",
					description: "Pflanzen, Pilze und Flora."
				},
				ORGANIZATION: {
					label: "Organisation",
					description: "Unternehmen, Regierungen, politische Parteien, Bündnisse, NGOs und Teams."
				},
				EVENT: {
					label: "Ereignis",
					description: "Kriege, Gipfeltreffen, Wahlen, Sportveranstaltungen, Katastrophen und historische Meilensteine."
				},
				PRODUCT: {
					label: "Produkt",
					description: "Konsumgüter, technische Geräte, Fahrzeuge, Software und Medientitel."
				},
				LAW: {
					label: "Gesetz",
					description: "Gesetze, Gesetzbücher, Gerichtsurteile und Verfassungsartikel."
				},
				OBJECT: {
					label: "Objekt",
					description: "Rohstoffe, militärische Ausrüstung sowie chemische und biologische Kampfstoffe."
				},
				CONCEPT: {
					label: "Konzept",
					description: "Abstrakte Ideen, Themen, Sachverhalte und Begriffe."
				}
			},
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			deleteTagEntities: "Löschen",
			newButton: "Neue Entität",
			errorOnDeleting: "Fehler beim Löschen der Entität",
			errorOnLoadingContents: "Fehler beim Laden der Inhalte",
			messageDeleted: "Entität gelöscht",
			selectTag: "Entität auswählen",
			headerRelatedContents: "Veröffentlichte Inhalte",
			headerRelatedHubPages: "Verlinkte Hub-Pages",
			headerLatestPublishDate: "Neuester Artikel",
			headerSalienceScore: "Salienz-Score",
			messageDeleteTagEntitiesTitle: "Entität löschen",
			messageDeleteTagEntities: "Willst du diese Entität wirklich löschen?",
			messageDeleteTagEntitiesAssignment: "Willst du die Verbindung zu diesem Artikel wirklich löschen?",
			messageDeleteTagEntitiesAssignmentTitle: "Verbindung zwischen Artikel und Entität löschen",
			deleteTagEntitiesAssignment: "Löschen",
			errorOnDeletingAssignment: "Fehler beim Löschen der Zuordnung",
			messageDeletedAssignment: "Zuordnung gelöscht"
		},
		tagEntitiesEdit: {
			editHubPages: "Entität bearbeiten",
			label: "Titel",
			canonicalName: "Kanonischer Name",
			adjustEntityName: "Entitätsname anpassen",
			confirmNameChangeTitle: "Entitätsnamen ändern",
			confirmNameChangeMessage: "Möchtest du den Entitätsnamen wirklich von „{previousName}“ zu „{newName}“ ändern?",
			category: "Kategorie",
			addArticles: "Artikel hinzufügen",
			noContentAssignments: "Keine Inhaltszuordnungen",
			loadingContent: "Inhalt wird geladen",
			assignment: "Zuordnung",
			manualAssignment: "Manuelle Zuordnung",
			automaticAssignment: "Automatische Zuordnung (MDS)",
			contentTitle: "Hauptzeile",
			contentBrand: "Content-Marke",
			headerStatus: "Status",
			headerSalienceScore: "Salienz-Score",
			headerActions: "Aktionen",
			dpGoToArticle: "Zum Artikel",
			copyArticleUrl: "Artikel-URL kopieren",
			copiedArticleUrl: "Artikel-URL kopiert",
			messageSaved: "Entität gespeichert"
		},
		peopleProfileHubPages: {
			firstName: "Vorname",
			lastName: "Nachname",
			birthDate: "Geburtsdatum",
			deathDate: "Todesdatum",
			birthPlace: "Geburtsort",
			size: "Größe (cm)",
			zodiacSign: "Sternzeichen",
			zodiacSigns: {
				aquarius: "Wassermann",
				pisces: "Fische",
				aries: "Widder",
				taurus: "Stier",
				gemini: "Zwillinge",
				cancer: "Krebs",
				leo: "Löwe",
				virgo: "Jungfrau",
				libra: "Waage",
				scorpio: "Skorpion",
				sagittarius: "Schütze",
				capricorn: "Steinbock"
			}
		}
	}
}, r = [{
	path: "/hub-pages",
	children: [
		{
			path: "",
			name: "hub_pages_list",
			component: () => import("./hub-pages-list.view-C7WPtFPc.js").then((e) => e.n),
			meta: { requiredRight: "hub-pages:navigate" }
		},
		{
			path: "new",
			name: "hub_pages_new",
			component: () => import("./hub-pages-edit.view-Do54PVWX.js").then((e) => e.n),
			props: () => ({ title: t().t("hubPages.newHubPages") }),
			meta: { requiredRight: ["hub-pages:navigate"] }
		},
		{
			path: ":id",
			name: "hub_pages_detail",
			component: () => import("./hub-pages-edit.view-Do54PVWX.js").then((e) => e.n),
			props: (e) => ({
				title: t().t("hubPagesEdit.editHubPages"),
				id: e.params.id
			}),
			meta: { requiredRight: ["hub-pages:navigate"] }
		}
	]
}, {
	path: "/tag-entities",
	children: [
		{
			path: "",
			name: "tag_entities_list",
			component: () => import("./tag-entities-list.view-DP4NaB73.js").then((e) => e.n),
			meta: { requiredRight: "tag-entities:navigate" }
		},
		{
			path: "new",
			name: "tag_entities_new",
			component: () => import("./tag-entities-edit.view-CY9JSxXZ.js"),
			props: () => ({ title: t().t("tagEntities.newHubPages") }),
			meta: { requiredRight: ["tag-entities:navigate"] }
		},
		{
			path: ":id",
			name: "tag_entities_detail",
			component: () => import("./tag-entities-edit.view-CY9JSxXZ.js"),
			props: (e) => ({
				title: t().t("tagEntitiesEdit.editHubPages"),
				id: e.params.id
			}),
			meta: { requiredRight: ["tag-entities:navigate"] }
		}
	]
}], i = e(() => import("./hub-pages-content-block-VFj-2L89.js")), a = e(() => import("./hub-pages-list.view-C7WPtFPc.js").then((e) => e.n)), o = e(() => import("./people-profile-block-Db96lz8Q.js")), s = {
	messages: n,
	routes: r
};
//#endregion
export { s as i, a as n, o as r, i as t };

//# sourceMappingURL=src-Dyq02gZZ.js.map